export const MATERIAL_GROUPS = {
  aluminum: "Aluminum",
  steel: "Carbon & Alloy Steel",
  stainless: "Stainless Steel",
  hardox: "Hardox / Wear Plate",
  tool_steel: "Tool Steel",
  spring_steel: "Spring Steel",
  cast_iron: "Cast Iron",
  copper_alloy: "Copper Alloys",
  superalloy: "Superalloys",
  plastic: "Plastics & Composites",
};

export const MATERIAL_DATABASE = {
  aluminum_6061: { label: "Aluminum 6061-T6", group: "aluminum", sfm: 800, chipLoad: 0.005, hardnessHB: 95, machinability: 70 },
  aluminum_7075: { label: "Aluminum 7075-T6", group: "aluminum", sfm: 600, chipLoad: 0.004, hardnessHB: 150, machinability: 70 },
  aluminum_2024: { label: "Aluminum 2024-T3", group: "aluminum", sfm: 650, chipLoad: 0.004, hardnessHB: 120, machinability: 70 },
  aluminum_5052: { label: "Aluminum 5052-H32", group: "aluminum", sfm: 700, chipLoad: 0.005, hardnessHB: 60, machinability: 75 },
  aluminum_cast: { label: "Cast Aluminum", group: "aluminum", sfm: 500, chipLoad: 0.004, hardnessHB: 80, machinability: 65 },

  mild_steel: { label: "Mild Steel / A36", group: "steel", sfm: 200, chipLoad: 0.003, hardnessHB: 130, machinability: 65 },
  cold_rolled_steel: { label: "Cold Rolled Steel", group: "steel", sfm: 220, chipLoad: 0.003, hardnessHB: 126, machinability: 70 },
  hot_rolled_steel: { label: "Hot Rolled Steel", group: "steel", sfm: 190, chipLoad: 0.0028, hardnessHB: 130, machinability: 60 },
  steel_1018: { label: "Steel 1018", group: "steel", sfm: 220, chipLoad: 0.003, hardnessHB: 126, machinability: 70 },
  steel_1045: { label: "Steel 1045", group: "steel", sfm: 160, chipLoad: 0.0028, hardnessHB: 180, machinability: 55 },
  steel_1144: { label: "Stressproof / 1144", group: "steel", sfm: 190, chipLoad: 0.003, hardnessHB: 220, machinability: 83 },
  alloy_steel: { label: "Alloy Steel", group: "steel", sfm: 150, chipLoad: 0.0025, hardnessHB: 220, machinability: 45 },
  steel_4140_annealed: { label: "4140 Annealed", group: "steel", sfm: 150, chipLoad: 0.0025, hardnessHB: 197, machinability: 55 },
  steel_4140_ph: { label: "4140 Pre-Hard", group: "steel", sfm: 110, chipLoad: 0.002, hardnessHB: 300, machinability: 45 },
  steel_4150: { label: "4150 Alloy Steel", group: "steel", sfm: 125, chipLoad: 0.0022, hardnessHB: 240, machinability: 48, densityLbIn3: 0.283, thermalExpansionPpmC: 11.5, heatTreatmentNotes: "Alloy steel; verify heat-treated condition and hardness before final cutting data.", searchKeywords: ["4150", "alloy steel", "chrome moly"] },
  steel_4340: { label: "4340 Alloy Steel", group: "steel", sfm: 110, chipLoad: 0.002, hardnessHB: 260, machinability: 45 },
  steel_8620: { label: "8620 Alloy Steel", group: "steel", sfm: 170, chipLoad: 0.0028, hardnessHB: 180, machinability: 65 },
  steel_12l14: { label: "12L14 Free-Machining Steel", group: "steel", sfm: 325, chipLoad: 0.004, hardnessHB: 160, machinability: 170 },
  steel_ar400: { label: "AR400 Wear Plate", group: "steel", sfm: 70, chipLoad: 0.0016, hardnessHB: 400, machinability: 25 },
  steel_ar500: { label: "AR500 Wear Plate", group: "steel", sfm: 50, chipLoad: 0.0012, hardnessHB: 500, machinability: 18 },

  hardox_400: { label: "Hardox 400", group: "hardox", sfm: 70, chipLoad: 0.0016, hardnessHB: 400, machinability: 25 },
  hardox_450: { label: "Hardox 450", group: "hardox", sfm: 60, chipLoad: 0.0014, hardnessHB: 450, machinability: 22 },
  hardox_500: { label: "Hardox 500", group: "hardox", sfm: 50, chipLoad: 0.0012, hardnessHB: 500, machinability: 18 },
  hardox_500_tuf: { label: "Hardox 500 Tuf", group: "hardox", sfm: 48, chipLoad: 0.0012, hardnessHB: 500, machinability: 18 },
  hardox_550: { label: "Hardox 550", group: "hardox", sfm: 42, chipLoad: 0.001, hardnessHB: 550, machinability: 15 },
  hardox_600: { label: "Hardox 600", group: "hardox", sfm: 34, chipLoad: 0.0009, hardnessHB: 600, machinability: 12 },
  hardox_extreme: { label: "Hardox Extreme", group: "hardox", sfm: 26, chipLoad: 0.0007, hardnessHB: 650, machinability: 8 },
  hardox_hitemp: { label: "Hardox HiTemp", group: "hardox", sfm: 58, chipLoad: 0.0013, hardnessHB: 450, machinability: 20 },
  hardox_hiace: { label: "Hardox HiAce", group: "hardox", sfm: 58, chipLoad: 0.0013, hardnessHB: 450, machinability: 20 },
  hardox_hituf: { label: "Hardox HiTuf", group: "hardox", sfm: 75, chipLoad: 0.0017, hardnessHB: 350, machinability: 28 },

  stainless_303: { label: "Stainless 303", group: "stainless", sfm: 160, chipLoad: 0.0023, hardnessHB: 190, machinability: 78 },
  stainless_304: { label: "Stainless 304", group: "stainless", sfm: 120, chipLoad: 0.002, hardnessHB: 180, machinability: 45 },
  stainless_316: { label: "Stainless 316", group: "stainless", sfm: 100, chipLoad: 0.0018, hardnessHB: 180, machinability: 36 },
  stainless_410: { label: "Stainless 410", group: "stainless", sfm: 110, chipLoad: 0.0018, hardnessHB: 200, machinability: 50 },
  stainless_416: { label: "Stainless 416", group: "stainless", sfm: 180, chipLoad: 0.0024, hardnessHB: 200, machinability: 85 },
  stainless_17_4: { label: "Stainless 17-4 PH", group: "stainless", sfm: 90, chipLoad: 0.0016, hardnessHB: 330, machinability: 35 },
  stainless_duplex_2205: { label: "Duplex Stainless 2205", group: "stainless", sfm: 70, chipLoad: 0.0014, hardnessHB: 290, machinability: 30 },

  tool_steel: { label: "Tool Steel General", group: "tool_steel", sfm: 80, chipLoad: 0.0015, hardnessHB: 240, machinability: 35 },
  tool_steel_a2: { label: "A2 Tool Steel", group: "tool_steel", sfm: 75, chipLoad: 0.0014, hardnessHB: 220, machinability: 40 },
  tool_steel_d2: { label: "D2 Tool Steel", group: "tool_steel", sfm: 55, chipLoad: 0.0012, hardnessHB: 255, machinability: 28 },
  tool_steel_o1: { label: "O1 Tool Steel", group: "tool_steel", sfm: 80, chipLoad: 0.0015, hardnessHB: 220, machinability: 45 },
  tool_steel_s7: { label: "S7 Tool Steel", group: "tool_steel", sfm: 70, chipLoad: 0.0014, hardnessHB: 230, machinability: 40 },
  tool_steel_h13: { label: "H13 Tool Steel", group: "tool_steel", sfm: 70, chipLoad: 0.0013, hardnessHB: 235, machinability: 35 },

  spring_steel_1074: { label: "AISI 1074 Spring Steel", group: "spring_steel", sfm: 95, chipLoad: 0.0018, hardnessHB: 240, machinability: 40, densityLbIn3: 0.283, thermalExpansionPpmC: 11.5, hardnessRockwellTypical: "Typical annealed/tempered range varies; often approx 20-50 HRC depending on temper", commonUses: "Springs, clips, blades, flat spring stock", heatTreatmentNotes: "High-carbon spring steel. Machining data depends strongly on annealed vs hardened/tempered condition.", searchKeywords: ["spring steel", "1074", "flat spring", "blue tempered"], sourceNotes: "Typical shop-estimate values; verify hardness and temper from supplier cert." },
  spring_steel_1075: { label: "AISI 1075 Spring Steel", group: "spring_steel", sfm: 90, chipLoad: 0.0017, hardnessHB: 250, machinability: 38, densityLbIn3: 0.283, thermalExpansionPpmC: 11.5, hardnessRockwellTypical: "Typical annealed/tempered range varies; often approx 22-52 HRC depending on temper", commonUses: "Flat springs, cutting tools, clips, wear strips", heatTreatmentNotes: "Higher carbon content increases hardenability and tool wear as hardness rises.", searchKeywords: ["spring steel", "1075", "flat spring", "hardened spring"], sourceNotes: "Typical shop-estimate values; verify hardness and temper from supplier cert." },
  spring_steel_1080: { label: "AISI 1080 Spring Steel", group: "spring_steel", sfm: 85, chipLoad: 0.0016, hardnessHB: 260, machinability: 36, densityLbIn3: 0.283, thermalExpansionPpmC: 11.5, hardnessRockwellTypical: "Typical annealed/tempered range varies; often approx 24-54 HRC depending on temper", commonUses: "Springs, blades, wear parts", heatTreatmentNotes: "High-carbon steel; annealed stock machines much differently than hardened spring temper.", searchKeywords: ["spring steel", "1080", "high carbon spring"], sourceNotes: "Typical shop-estimate values; verify hardness and temper from supplier cert." },
  spring_steel_1095: { label: "AISI 1095 Spring Steel", group: "spring_steel", sfm: 75, chipLoad: 0.0014, hardnessHB: 290, machinability: 30, densityLbIn3: 0.283, thermalExpansionPpmC: 11.5, hardnessRockwellTypical: "Typical hardened spring temper can be high; annealed stock is much lower", commonUses: "Springs, blades, shims, feeler stock", heatTreatmentNotes: "Very high carbon. Avoid rubbing and verify condition before choosing feeds/speeds.", searchKeywords: ["spring steel", "1095", "high carbon spring", "shim stock"], sourceNotes: "Typical shop-estimate values; verify hardness and temper from supplier cert." },
  spring_steel_5160: { label: "5160 Chromium Spring Steel", group: "spring_steel", sfm: 85, chipLoad: 0.0016, hardnessHB: 260, machinability: 35, densityLbIn3: 0.283, thermalExpansionPpmC: 11.2, hardnessRockwellTypical: "Typical range varies by heat treat; hardened/tempered spring parts may be much harder than annealed bar", commonUses: "Leaf springs, suspension parts, heavy springs", heatTreatmentNotes: "Chromium spring steel; heat-treated condition drives machinability and tool wear.", searchKeywords: ["spring steel", "5160", "leaf spring", "chromium spring"], sourceNotes: "Typical shop-estimate values; verify alloy condition and hardness." },
  spring_steel_6150: { label: "6150 Chromium-Vanadium Spring Steel", group: "spring_steel", sfm: 75, chipLoad: 0.0014, hardnessHB: 285, machinability: 30, densityLbIn3: 0.283, thermalExpansionPpmC: 11.2, hardnessRockwellTypical: "Typical range varies by heat treat; often specified by final hardness for springs", commonUses: "High-stress springs, shafts, torsion bars", heatTreatmentNotes: "Chromium-vanadium alloy spring steel. Use conservative data if heat treated.", searchKeywords: ["spring steel", "6150", "chrome vanadium", "torsion bar"], sourceNotes: "Typical shop-estimate values; verify alloy condition and hardness." },
  spring_steel_9260: { label: "9260 Silicon Spring Steel", group: "spring_steel", sfm: 80, chipLoad: 0.0015, hardnessHB: 270, machinability: 32, densityLbIn3: 0.283, thermalExpansionPpmC: 11.5, hardnessRockwellTypical: "Typical range varies by heat treat and supplier", commonUses: "Coil springs, blades, high-resilience parts", heatTreatmentNotes: "Silicon spring steel. Confirm temper and avoid aggressive data on hardened parts.", searchKeywords: ["spring steel", "9260", "silicon spring", "coil spring"], sourceNotes: "Typical shop-estimate values; verify alloy condition and hardness." },
  spring_stainless_17_7: { label: "17-7 PH Stainless Spring Steel", group: "spring_steel", sfm: 65, chipLoad: 0.0012, hardnessHB: 330, machinability: 25, densityLbIn3: 0.282, thermalExpansionPpmC: 10.8, hardnessRockwellTypical: "Condition dependent; precipitation-hardened spring tempers vary by specification", commonUses: "Corrosion-resistant springs, aerospace clips, diaphragms", heatTreatmentNotes: "Precipitation-hardening stainless. Verify condition such as CH900/RH950 before machining.", searchKeywords: ["spring steel", "17-7", "17-7 PH", "stainless spring", "spring temper"], sourceNotes: "Typical shop-estimate values; verify condition and hardness from cert." },
  spring_stainless_301: { label: "301 Stainless Spring Steel", group: "spring_steel", sfm: 85, chipLoad: 0.0014, hardnessHB: 300, machinability: 28, densityLbIn3: 0.289, thermalExpansionPpmC: 16.9, hardnessRockwellTypical: "Spring temper depends on cold work; verify 1/2 hard/full hard/spring temper condition", commonUses: "Stainless springs, clips, washers", heatTreatmentNotes: "Work-hardening austenitic stainless. Keep tools sharp and maintain chip load.", searchKeywords: ["spring steel", "301", "stainless spring", "spring temper"], sourceNotes: "Typical shop-estimate values; verify temper and hardness from supplier." },
  spring_stainless_302: { label: "302 Stainless Spring Steel", group: "spring_steel", sfm: 80, chipLoad: 0.0013, hardnessHB: 290, machinability: 28, densityLbIn3: 0.289, thermalExpansionPpmC: 17.2, hardnessRockwellTypical: "Spring temper depends on cold work; verify supplied condition", commonUses: "Wire springs, formed springs, corrosion-resistant clips", heatTreatmentNotes: "Austenitic stainless spring material. Work hardening and wire condition affect machining.", searchKeywords: ["spring steel", "302", "stainless spring", "spring temper"], sourceNotes: "Typical shop-estimate values; verify temper and hardness from supplier." },
  spring_stainless_304_temper: { label: "304 Stainless Spring Temper", group: "spring_steel", sfm: 75, chipLoad: 0.0012, hardnessHB: 300, machinability: 25, densityLbIn3: 0.289, thermalExpansionPpmC: 17.3, hardnessRockwellTypical: "Cold-worked spring temper varies; verify actual condition", commonUses: "Stainless spring clips, flat springs, shims", heatTreatmentNotes: "Work-hardening stainless. Reduce rubbing and verify tool pressure/heat control.", searchKeywords: ["spring steel", "304", "stainless spring", "spring temper"], sourceNotes: "Typical shop-estimate values; verify temper and hardness from supplier." },
  music_wire_astm_a228: { label: "Music Wire / ASTM A228", group: "spring_steel", sfm: 70, chipLoad: 0.0012, hardnessHB: 360, machinability: 20, densityLbIn3: 0.283, thermalExpansionPpmC: 11.5, hardnessRockwellTypical: "Cold drawn high-carbon wire; hardness and tensile strength vary by diameter", commonUses: "Precision coil springs, wire forms, small high-strength springs", heatTreatmentNotes: "Usually supplied cold drawn. Avoid assuming annealed machining behavior.", searchKeywords: ["spring steel", "music wire", "ASTM A228", "spring wire", "1095 wire"], sourceNotes: "Typical shop-estimate values; use wire supplier data for final design." },

  cast_iron: { label: "Gray Cast Iron", group: "cast_iron", sfm: 300, chipLoad: 0.004, hardnessHB: 200, machinability: 80 },
  ductile_iron: { label: "Ductile Iron", group: "cast_iron", sfm: 220, chipLoad: 0.003, hardnessHB: 220, machinability: 65 },
  cast_iron_class_40: { label: "Class 40 Cast Iron", group: "cast_iron", sfm: 240, chipLoad: 0.0035, hardnessHB: 235, machinability: 70 },

  brass: { label: "Brass", group: "copper_alloy", sfm: 600, chipLoad: 0.004, hardnessHB: 80, machinability: 100 },
  bronze: { label: "Bronze", group: "copper_alloy", sfm: 400, chipLoad: 0.003, hardnessHB: 100, machinability: 60 },
  copper: { label: "Copper", group: "copper_alloy", sfm: 350, chipLoad: 0.003, hardnessHB: 50, machinability: 45 },
  copper_beryllium: { label: "Beryllium Copper", group: "copper_alloy", sfm: 250, chipLoad: 0.0025, hardnessHB: 200, machinability: 45 },

  titanium: { label: "Titanium Grade 2", group: "superalloy", sfm: 70, chipLoad: 0.001, hardnessHB: 160, machinability: 30 },
  titanium_6al4v: { label: "Titanium 6Al-4V", group: "superalloy", sfm: 55, chipLoad: 0.0009, hardnessHB: 330, machinability: 22 },
  inconel: { label: "Inconel 625/718", group: "superalloy", sfm: 50, chipLoad: 0.0008, hardnessHB: 330, machinability: 15 },
  hastelloy: { label: "Hastelloy", group: "superalloy", sfm: 45, chipLoad: 0.0008, hardnessHB: 240, machinability: 18 },
  monel: { label: "Monel", group: "superalloy", sfm: 65, chipLoad: 0.001, hardnessHB: 150, machinability: 25 },

  acetal: { label: "Acetal / Delrin", group: "plastic", sfm: 700, chipLoad: 0.006, hardnessHB: 15, machinability: 90 },
  nylon: { label: "Nylon", group: "plastic", sfm: 500, chipLoad: 0.005, hardnessHB: 12, machinability: 80 },
  hdpe: { label: "HDPE", group: "plastic", sfm: 600, chipLoad: 0.006, hardnessHB: 8, machinability: 85 },
  phenolic: { label: "Phenolic", group: "plastic", sfm: 300, chipLoad: 0.003, hardnessHB: 35, machinability: 60 },
};

const GROUP_ENGINEERING_PROPERTIES = {
  aluminum: { densityLbIn3: 0.0975, thermalExpansionPpmC: 23, tensilePsiEstimate: 30000, castingShrinkagePercent: 1.3 },
  steel: { densityLbIn3: 0.283, thermalExpansionPpmC: 12, tensilePsiEstimate: 60000, castingShrinkagePercent: 2 },
  stainless: { densityLbIn3: 0.289, thermalExpansionPpmC: 17.3, tensilePsiEstimate: 90000, castingShrinkagePercent: 2 },
  hardox: { densityLbIn3: 0.283, thermalExpansionPpmC: 11.5, tensilePsiEstimate: 180000 },
  tool_steel: { densityLbIn3: 0.284, thermalExpansionPpmC: 11.5, tensilePsiEstimate: 100000 },
  spring_steel: { densityLbIn3: 0.283, thermalExpansionPpmC: 11.5, tensilePsiEstimate: 90000 },
  cast_iron: { densityLbIn3: 0.26, thermalExpansionPpmC: 10.8, tensilePsiEstimate: 40000, castingShrinkagePercent: 1 },
  copper_alloy: { densityLbIn3: 0.307, thermalExpansionPpmC: 18.5, tensilePsiEstimate: 50000, castingShrinkagePercent: 1.5 },
  superalloy: { densityLbIn3: 0.163, thermalExpansionPpmC: 8.6, tensilePsiEstimate: 70000 },
  plastic: { densityLbIn3: 0.05, thermalExpansionPpmC: 80, tensilePsiEstimate: 8000 },
};

const MATERIAL_PROPERTY_OVERRIDES = {
  copper: { densityLbIn3: 0.323, thermalExpansionPpmC: 16.5 },
  brass: { densityLbIn3: 0.307, thermalExpansionPpmC: 19, castingShrinkagePercent: 1.5 },
  bronze: { densityLbIn3: 0.32, thermalExpansionPpmC: 18, castingShrinkagePercent: 1.5 },
  copper_beryllium: { densityLbIn3: 0.298, thermalExpansionPpmC: 17 },
  titanium: { densityLbIn3: 0.163, thermalExpansionPpmC: 8.6 },
  titanium_6al4v: { densityLbIn3: 0.16, thermalExpansionPpmC: 8.6 },
  inconel: { densityLbIn3: 0.305, thermalExpansionPpmC: 13 },
  hastelloy: { densityLbIn3: 0.321, thermalExpansionPpmC: 12 },
  monel: { densityLbIn3: 0.319, thermalExpansionPpmC: 14 },
  acetal: { densityLbIn3: 0.051, thermalExpansionPpmC: 100 },
  nylon: { densityLbIn3: 0.041, thermalExpansionPpmC: 90 },
  hdpe: { densityLbIn3: 0.034, thermalExpansionPpmC: 120 },
  phenolic: { densityLbIn3: 0.05, thermalExpansionPpmC: 35 },
  stainless_17_4: { densityLbIn3: 0.282, thermalExpansionPpmC: 10.8 },
};

export const getMaterialEngineeringProperties = (id) => {
  const material = MATERIAL_DATABASE[id];
  if (!material) return null;
  return {
    ...GROUP_ENGINEERING_PROPERTIES[material.group],
    ...material,
    ...MATERIAL_PROPERTY_OVERRIDES[id],
    id,
    name: material.label,
    category: MATERIAL_GROUPS[material.group] || material.group,
    density: material.densityLbIn3 || MATERIAL_PROPERTY_OVERRIDES[id]?.densityLbIn3 || GROUP_ENGINEERING_PROPERTIES[material.group]?.densityLbIn3,
    thermalExpansion: material.thermalExpansionPpmC || MATERIAL_PROPERTY_OVERRIDES[id]?.thermalExpansionPpmC || GROUP_ENGINEERING_PROPERTIES[material.group]?.thermalExpansionPpmC,
    hardnessRockwell: material.hardnessRockwellTypical || "",
    weldability: material.weldability || (
      ["plastic", "cast_iron", "hardox", "tool_steel", "spring_steel"].includes(material.group)
        ? "Special process review required; verify exact grade, condition, filler/process, preheat, and qualified procedure."
        : "Condition-dependent; verify exact alloy and qualified shop/WPS requirements."
    ),
    notes: material.heatTreatmentNotes || material.sourceNotes || "",
    searchTags: material.searchKeywords || [material.label, material.group],
  };
};

export const MANUFACTURING_MATERIAL_OPTIONS = Object.keys(MATERIAL_DATABASE)
  .map(getMaterialEngineeringProperties)
  .filter((material) => Number.isFinite(material?.densityLbIn3))
  .map((material) => ({ ...material, lbIn3: material.densityLbIn3 }));

const PRESS_BRAKE_MATERIAL_IDS = [
  "mild_steel",
  "cold_rolled_steel",
  "hot_rolled_steel",
  "steel_1018",
  "aluminum_5052",
  "aluminum_6061",
  "stainless_304",
  "stainless_316",
  "brass",
];

export const PRESS_BRAKE_MATERIALS = MANUFACTURING_MATERIAL_OPTIONS
  .filter((material) => PRESS_BRAKE_MATERIAL_IDS.includes(material.id))
  .filter((material) => Number.isFinite(material.tensilePsiEstimate))
  .map((material) => ({
    id: material.id,
    label: material.label,
    tensilePsi: material.tensilePsiEstimate,
    factor: material.tensilePsiEstimate / 60000,
  }));

const CASTING_MATERIAL_IDS = [
  "aluminum_cast",
  "brass",
  "bronze",
  "cast_iron",
  "ductile_iron",
  "mild_steel",
];

export const CASTING_SHRINKAGE_MATERIALS = MANUFACTURING_MATERIAL_OPTIONS
  .filter((material) => CASTING_MATERIAL_IDS.includes(material.id))
  .filter((material) => Number.isFinite(material.castingShrinkagePercent))
  .map((material) => ({
    id: material.id,
    label: material.label,
    rate: material.castingShrinkagePercent,
  }));

export const THERMAL_EXPANSION_MATERIALS = MANUFACTURING_MATERIAL_OPTIONS
  .filter((material) => Number.isFinite(material.thermalExpansionPpmC))
  .map((material) => ({
    id: material.id,
    label: material.label,
    ppmC: material.thermalExpansionPpmC,
  }));

export const HARDNESS_DATA_POLICY = {
  testStandard: "Rockwell testing: ASTM E18; conversion comparison: ASTM E140",
  conversionNote: "Rockwell values converted from Brinell are approximate comparisons only. Material condition, thickness, surface preparation, test force, and alloy affect validity. Use an actual hardness test or supplier certification for acceptance.",
  conditionNote: "Generic alloy names do not define hardness. Heat treatment, cold work, temper, product form, and supplier condition must be known before using hardness-sensitive cutting data.",
};

// Material SFM entries are treated as carbide-style starting points.
// HSS/cobalt reduce speed from that baseline; advanced tool materials still require manufacturer data.
export const TOOL_MATERIAL_MULTIPLIERS = {
  hss: 0.35,
  cobalt: 0.45,
  carbide: 1,
  solid_carbide: 1.05,
  indexable_carbide: 0.92,
  brazed_carbide: 0.82,
  ceramic: 1.35,
  cermet: 1.2,
  cbn: 1.1,
  pcd: 1.45,
};

export const TOOL_MATERIAL_OPTIONS = {
  hss: { label: "HSS", wearResistance: 0.85, baseLifeMinutes: 90 },
  cobalt: { label: "Cobalt HSS", wearResistance: 1, baseLifeMinutes: 120 },
  carbide: { label: "Carbide", wearResistance: 1.35, baseLifeMinutes: 180 },
  solid_carbide: { label: "Solid Carbide", wearResistance: 1.42, baseLifeMinutes: 190 },
  indexable_carbide: { label: "Indexable Carbide", wearResistance: 1.32, baseLifeMinutes: 170 },
  brazed_carbide: { label: "Brazed Carbide", wearResistance: 1.15, baseLifeMinutes: 145 },
  ceramic: { label: "Ceramic", wearResistance: 1.65, baseLifeMinutes: 140 },
  cermet: { label: "Cermet", wearResistance: 1.55, baseLifeMinutes: 150 },
  cbn: { label: "CBN", wearResistance: 1.9, baseLifeMinutes: 170 },
  pcd: { label: "PCD", wearResistance: 2.1, baseLifeMinutes: 220 },
};

export const TOOL_COATINGS = {
  uncoated: { label: "Uncoated", sfmMultiplier: 1, feedMultiplier: 1, wearResistanceMultiplier: 1 },
  tin: { label: "TiN", sfmMultiplier: 1.12, feedMultiplier: 1.03, wearResistanceMultiplier: 1.12 },
  ticn: { label: "TiCN", sfmMultiplier: 1.18, feedMultiplier: 1.05, wearResistanceMultiplier: 1.2 },
  tialn: { label: "TiAlN", sfmMultiplier: 1.28, feedMultiplier: 1.06, wearResistanceMultiplier: 1.32 },
  altin: { label: "AlTiN", sfmMultiplier: 1.32, feedMultiplier: 1.06, wearResistanceMultiplier: 1.38 },
  zrn: { label: "ZrN", sfmMultiplier: 1.15, feedMultiplier: 1.04, wearResistanceMultiplier: 1.16 },
  diamond_like: { label: "DLC / Diamond-like", sfmMultiplier: 1.22, feedMultiplier: 1.06, wearResistanceMultiplier: 1.35 },
};

export const UNIT_SYSTEM_OPTIONS = {
  imperial: "Imperial",
  metric: "Metric",
};

const interpolate = (value, points) => {
  if (!Number.isFinite(value)) return null;

  if (value <= points[0][0]) return points[0][1];
  if (value >= points[points.length - 1][0]) return points[points.length - 1][1];

  for (let index = 1; index < points.length; index += 1) {
    const [highHb, highRockwell] = points[index];
    const [lowHb, lowRockwell] = points[index - 1];

    if (value <= highHb) {
      const ratio = (value - lowHb) / (highHb - lowHb);
      return lowRockwell + ratio * (highRockwell - lowRockwell);
    }
  }

  return null;
};

const HRC_CONVERSION_POINTS = [
  [180, 10],
  [200, 13],
  [220, 18],
  [240, 22],
  [260, 26],
  [280, 29],
  [300, 32],
  [320, 34],
  [340, 36],
  [360, 38],
  [400, 43],
  [450, 48],
  [500, 52],
  [550, 55],
  [600, 58],
  [650, 60],
];

const HRB_CONVERSION_POINTS = [
  [60, 35],
  [80, 50],
  [100, 60],
  [120, 68],
  [140, 76],
  [160, 84],
  [180, 89],
];

export const ROCKWELL_COMPARISON_RANGES = {
  HRC: { min: 10, max: 60 },
  HRB: { min: 35, max: 89 },
};

export function rockwellToApproxBrinell(scale, value) {
  const normalizedScale = String(scale || "").toUpperCase();
  const rockwell = Number(value);
  const range = ROCKWELL_COMPARISON_RANGES[normalizedScale];
  if (!range || !Number.isFinite(rockwell) || rockwell < range.min || rockwell > range.max) {
    return null;
  }

  const source = normalizedScale === "HRC" ? HRC_CONVERSION_POINTS : HRB_CONVERSION_POINTS;
  const inversePoints = source.map(([brinell, comparison]) => [comparison, brinell]);
  return interpolate(rockwell, inversePoints);
}

export function getRockwellHardness(hardnessHB) {
  const hb = Number(hardnessHB);
  if (!Number.isFinite(hb) || hb <= 0) return "N/A";

  if (hb >= 180) {
    const hrc = interpolate(hb, HRC_CONVERSION_POINTS);
    return `Approx. ${Math.round(hrc)} HRC`;
  }

  const hrb = interpolate(hb, HRB_CONVERSION_POINTS);
  return `Approx. ${Math.round(hrb)} HRB`;
}

export const getMaterialLabel = (key) =>
  MATERIAL_DATABASE[key]?.label || String(key || "").replace(/_/g, " ");

export const getMaterialOptions = () =>
  Object.entries(MATERIAL_DATABASE).map(([value, material]) => ({
    value,
    label: material.label,
    group: MATERIAL_GROUPS[material.group] || material.group,
    sfm: material.sfm,
    chipLoad: material.chipLoad,
    hardnessHB: material.hardnessHB,
    hardnessRockwell: getRockwellHardness(material.hardnessHB),
    hardnessRockwellTypical: material.hardnessRockwellTypical,
    machinability: material.machinability,
    densityLbIn3: material.densityLbIn3,
    thermalExpansionPpmC: material.thermalExpansionPpmC,
    commonUses: material.commonUses,
    heatTreatmentNotes: material.heatTreatmentNotes,
    sourceNotes: material.sourceNotes,
    hardnessAuditNote: material.hardnessRockwellTypical || HARDNESS_DATA_POLICY.conversionNote,
    searchKeywords: material.searchKeywords || [],
  }));
